import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { App as AntdApp, ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import 'dayjs/locale/ru';
import { antdTheme } from './providers/antdTheme';
import { queryClient } from './providers/queryClient';
import { AppRouter } from './router/AppRouter';

import './styles.css';
import './styles/v2.css';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={antdTheme} locale={ruRU}>
        <AntdApp>
          <AppRouter />
        </AntdApp>
      </ConfigProvider>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
